import { ActionTree } from "vuex";
import { ISupplierState } from "./state";
import { AxiosResponse } from "axios";
import { ISupplier } from "@/models";
import { apiClient } from "@/services";
import { ADD_SUPLLIERS, SET_SUPPLIERS } from "./mutations-types";

export const actions: ActionTree<ISupplierState, number> = {

    async fetchSuppliers(context): Promise<AxiosResponse<ISupplier[]>> {
        const response = await apiClient.get<ISupplier[]>(`/suppliers`);
        context.commit(ADD_SUPLLIERS, response.data);

        return response;
    },

    async fetchSuppliersByPrefix(context, data: string): Promise<AxiosResponse<ISupplier[]>> {
        const response = await apiClient.get<ISupplier[]>(`/suppliers/search?prefix=${data}`);
        context.commit(SET_SUPPLIERS, response.data);

        return response;
    },
};
